import { render, staticRenderFns } from "./SistemasSobMedidaBC.vue?vue&type=template&id=1ae16d84&scoped=true"
import script from "./SistemasSobMedidaBC.vue?vue&type=script&lang=js"
export * from "./SistemasSobMedidaBC.vue?vue&type=script&lang=js"
import style0 from "./SistemasSobMedidaBC.vue?vue&type=style&index=0&id=1ae16d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae16d84",
  null
  
)

export default component.exports